import { createContext, useState } from "react";
const ExportRelatorioContext = createContext();

const ExportRelatorioProvider = ({ children }) => {
  const [colunas, setColunas] = useState([]);
  const [filtros, setFiltros] = useState([]);
  const [valoresFiltros, setValoresFiltros] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [apuracao, setApuracao] = useState(false);
  const [penddingSave, setPenddingSave] = useState({
    pendding: false,
    helpertext: "",
    error: false,
  });

  const [idFiltroSavoContasContabeis, setIdFiltroSavoContasContabeis] =
    useState([]);

  const handleClose = () => {
    setColunas([]);
    setFiltros([]);
    setValoresFiltros([]);
    setEmpresas([]);
    setApuracao(false);
    setPenddingSave({ pendding: false, helpertext: "", error: false });

    setIdFiltroSavoContasContabeis([])
  };

  return (
    <ExportRelatorioContext.Provider
      value={{
        colunas,
        setColunas,
        filtros,
        setFiltros,
        valoresFiltros,
        setValoresFiltros,
        empresas,
        setEmpresas,
        apuracao,
        setApuracao,
        handleClose,
        setPenddingSave,
        penddingSave,
        idFiltroSavoContasContabeis,
        setIdFiltroSavoContasContabeis,
      }}
    >
      {children}
    </ExportRelatorioContext.Provider>
  );
};

export { ExportRelatorioContext, ExportRelatorioProvider };
